import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import BreakingNewsTicker from "@/pages/home/components/BreakingNewsTicker";
import AdvertSection from "@/pages/home/components/AdvertSection";
import LiveNowSection from "@/pages/home/components/LiveNowSection";
import LatestNewsSection from "@/pages/home/components/LatestNewsSection";
import FeaturedProgramsSection from "@/pages/home/components/FeaturedProgramsSection";
import ProgramsShowcaseSection from "@/pages/home/components/ProgramsShowcaseSection";
import LatestVideosSection from "@/pages/home/components/LatestVideosSection";
import SocialMediaSection from "@/pages/home/components/SocialMediaSection";
import NewsletterSection from "@/pages/home/components/NewsletterSection";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <BreakingNewsTicker />
      <AdvertSection />
      <LiveNowSection />
      <LatestNewsSection />
      <FeaturedProgramsSection />
      <ProgramsShowcaseSection />
      <LatestVideosSection />
      <SocialMediaSection />
      <NewsletterSection />
    </>
  );
}